import { Routes, Route } from 'react-router-dom'
import { AuthProvider } from './contextos/autenticacion/ContextoAutenticacion'
import { ProveedorTema } from './contextos/tema/ContextoTema'
import { Toaster } from './componentes/interfaz-usuario/notificaciones/Notificador'
import { Toaster as HotToaster } from 'react-hot-toast'
import ProtectedRoute from './componentes/autenticacion/RutaProtegida'
import PublicRoute from './componentes/autenticacion/RutaPublica'

// Layouts
import LayoutPrincipal from './componentes/layout/LayoutPrincipal'
import LayoutAdmin from './componentes/layout/LayoutAdmin'
import LayoutInstitucional from './componentes/layout/LayoutInstitucional'
import LayoutEmpresa from './componentes/layout/LayoutEmpresa'

// Páginas públicas
import PaginaInicio from './paginas/principales/inicio/PaginaInicio'
import { PaginaLogin, PaginaRegistro } from './paginas/Login_u_Registro'
import PaginaResetPassword from './paginas/Login_u_Registro/PaginaResetPassword'
import PaginaEtiquetaProductoQR from './paginas/principales/almacen/PaginaEtiquetaProductoQR'

// Páginas protegidas
import PaginaDashboardUsuario from './paginas/panel-usuario/dashboard/PaginaDashboardUsuario'
import PaginaDashboardAdmin from './paginas/panel-admin/dashboard/PaginaDashboardAdmin'
import PaginaHomeUsuario from './paginas/panel-usuario/home/PaginaHomeUsuario'
import PaginaInformacion from './paginas/principales/informacion/PaginaInformacion'

// Páginas de administración
import PaginaGestionUsuarios from './paginas/panel-admin/usuarios/PaginaGestionUsuarios'
import PaginaRolesPermisos from './paginas/panel-admin/usuarios/PaginaRolesPermisos'
import PaginaGestionInstituciones from './paginas/panel-admin/instituciones/PaginaGestionInstituciones'
import PaginaGestionCategorias from './paginas/panel-admin/configuracion/PaginaGestionCategorias'
import PaginaConfiguracionSistema from './paginas/panel-admin/configuracion/PaginaConfiguracionSistema'
import PaginaGestionArchivos from './paginas/panel-admin/envios/PaginaGestionArchivos'
import PaginaReportesAnaliticas from './paginas/panel-admin/reportes/PaginaReportesAnaliticas'
import PaginaGestionNormativa from './paginas/panel-admin/normatividad/PaginaGestionNormativa'
import PaginaEditorNormativa from './paginas/panel-admin/normatividad/PaginaEditorNormativa'
import PaginaAuditoriaAdmin from './paginas/panel-admin/monitoreo/PaginaAuditoriaAdmin'

// Páginas de envíos
import PaginaPanelEnvios from './paginas/panel-usuario/envios/PaginaPanelEnvios'
import PaginaCrearEnvio from './paginas/panel-usuario/envios/PaginaCrearEnvio'
import PaginaDetalleEnvio from './paginas/panel-usuario/envios/PaginaDetalleEnvio'
import PaginaSeguimientoEnvio from './paginas/panel-usuario/envios/PaginaSeguimientoEnvio'

// Páginas de flota
import PaginaListaFlota from './paginas/panel-usuario/flota/PaginaListaFlota'
import PaginaConductores from './paginas/panel-usuario/flota/PaginaConductores'
import PaginaMantenimiento from './paginas/panel-usuario/flota/PaginaMantenimiento'

// Páginas de operaciones
import PaginaHistorialOperaciones from './paginas/panel-usuario/operaciones/PaginaHistorialOperaciones'
import PaginaSeguimientoEnVivo from './paginas/panel-usuario/operaciones/PaginaSeguimientoEnVivo'

// Páginas de permisos y licencias
import PaginaLicencias from './paginas/panel-usuario/permisos/PaginaLicencias'

// Páginas de tarifas
import PaginaBuscadorLigie from './paginas/panel-usuario/tarifas/PaginaBuscadorLigie'

// Páginas de reportes
import PaginaReporteRendimiento from './paginas/panel-usuario/reportes/PaginaReporteRendimiento'
import PaginaReporteFinanciero from './paginas/panel-usuario/reportes/PaginaReporteFinanciero'

// Páginas de configuración
import PaginaPerfil from './paginas/panel-usuario/configuracion/PaginaPerfil'

import PaginaDashboardInstitucion from './paginas/panel-institucion/dashboard/PaginaDashboardInstitucion'
import PaginaPanelJefes from './paginas/panel-institucion/jefes/PaginaPanelJefes'
import PaginaGestionMiembros from './paginas/panel-institucion/jefes/PaginaGestionMiembros'
import PaginaPanelUsuarios from './paginas/panel-institucion/usuarios/PaginaPanelUsuarios'
import PaginaPerfilJefe from './paginas/panel-institucion/jefes/PaginaPerfilJefe'
import PaginaPerfilAlumno from './paginas/panel-institucion/usuarios/PaginaPerfilAlumno'
import PaginaVisorNormativa from './paginas/panel-institucion/usuarios/PaginaVisorNormativa'
import PaginaNormativaGeneral from './paginas/comunes/PaginaNormativaGeneral'
import PaginaDetalleDictamen from './paginas/panel-institucion/dictamenes/PaginaDetalleDictamen'
import PaginaSimulacionCasoA from './paginas/panel-institucion/simulaciones/PaginaSimulacionCasoA'
import PaginaConfiguracionSimulacion from './paginas/panel-institucion/simulaciones/PaginaConfiguracionSimulacion'
import PaginaEvaluacionSimulacion from './paginas/panel-institucion/simulaciones/PaginaEvaluacionSimulacion'
import PaginaPanelEmpresa from './paginas/panel-empresa/dashboard/PaginaPanelEmpresa'
import PaginaGestionEmpresa from './paginas/panel-empresa/gestion/PaginaGestionEmpresa'
import PaginaAlmacenPractica from './paginas/panel-institucion/usuarios/PaginaAlmacenPractica'
import PaginaDespachoPortuario from './paginas/panel-institucion/despacho/PaginaDespachoPortuario'

// Páginas de error
import PaginaNoEncontrada from './paginas/errores/404/PaginaNoEncontrada'

function App() {
  return (
    <ProveedorTema>
      <AuthProvider>
        <div className="theme-transition min-h-screen bg-gray-50 dark:bg-gray-900">
        <Routes>
          {/* Rutas públicas */}
          <Route 
            path="/" 
            element={
              <PublicRoute>
                <PaginaInicio />
              </PublicRoute>
            } 
          />
          <Route 
            path="/login" 
            element={
              <PublicRoute>
                <PaginaLogin />
              </PublicRoute>
            } 
          />
          <Route 
            path="/register" 
            element={
              <PublicRoute>
                <PaginaRegistro />
              </PublicRoute>
            } 
          />
          <Route
            path="/forgot-password"
            element={
              <PublicRoute>
                <PaginaResetPassword />
              </PublicRoute>
            }
          />
          <Route
            path="/reset-password"
            element={
              <PublicRoute>
                <PaginaResetPassword />
              </PublicRoute>
            }
          />
          <Route path="/information" element={<PaginaInformacion />} />
          <Route path="/qr/almacen/etiqueta" element={<PaginaEtiquetaProductoQR />} />

          {/* Rutas protegidas para usuarios */}
          <Route path="/dashboard" element={
            <ProtectedRoute requiredRole="user">
              <LayoutPrincipal>
                <PaginaDashboardUsuario />
              </LayoutPrincipal>
            </ProtectedRoute>
          } />
          <Route path="/home" element={
            <ProtectedRoute requiredRole="user">
              <LayoutPrincipal>
                <PaginaHomeUsuario />
              </LayoutPrincipal>
            </ProtectedRoute>
          } />

          {/* Rutas de normatividad (Usuario) */}
          <Route path="/dashboard/normatividad" element={
            <ProtectedRoute requiredRole="user">
              <LayoutPrincipal>
                <PaginaNormativaGeneral basePath="/dashboard/normatividad" />
              </LayoutPrincipal>
            </ProtectedRoute>
          } />
          <Route path="/dashboard/normatividad/:id" element={
            <ProtectedRoute requiredRole="user">
              <LayoutPrincipal>
                <PaginaVisorNormativa />
              </LayoutPrincipal>
            </ProtectedRoute>
          } />

          {/* Rutas de tarifas */}
          <Route path="/tarifas/clasificacion" element={
            <ProtectedRoute requiredRole="user">
              <LayoutPrincipal>
                <PaginaBuscadorLigie />
              </LayoutPrincipal>
            </ProtectedRoute>
          } />

          {/* Rutas de envíos */}
          <Route path="/dashboard/envios" element={
            <ProtectedRoute requiredRole="user">
              <LayoutPrincipal>
                <PaginaPanelEnvios />
              </LayoutPrincipal>
            </ProtectedRoute>
          } />
          <Route path="/dashboard/envios/crear" element={
            <ProtectedRoute requiredRole="user">
              <LayoutPrincipal>
                <PaginaCrearEnvio />
              </LayoutPrincipal>
            </ProtectedRoute>
          } />
          <Route path="/dashboard/envios/:id" element={
            <ProtectedRoute requiredRole="user">
              <LayoutPrincipal>
                <PaginaDetalleEnvio />
              </LayoutPrincipal>
            </ProtectedRoute>
          } />
          <Route path="/dashboard/envios/:id/seguimiento" element={
            <ProtectedRoute requiredRole="user">
              <LayoutPrincipal>
                <PaginaSeguimientoEnvio />
              </LayoutPrincipal>
            </ProtectedRoute>
          } />

          {/* Rutas de flota */}
          <Route path="/flota" element={
            <ProtectedRoute requiredRole="user">
              <LayoutPrincipal>
                <PaginaListaFlota />
              </LayoutPrincipal>
            </ProtectedRoute>
          } />
          <Route path="/flota/conductores" element={
            <ProtectedRoute requiredRole="user">
              <LayoutPrincipal>
                <PaginaConductores />
              </LayoutPrincipal>
            </ProtectedRoute>
          } />
          <Route path="/flota/mantenimiento" element={
            <ProtectedRoute requiredRole="user">
              <LayoutPrincipal>
                <PaginaMantenimiento />
              </LayoutPrincipal>
            </ProtectedRoute>
          } />

          {/* Rutas de operaciones */}
          <Route path="/operaciones/seguimiento" element={
            <ProtectedRoute requiredRole="user">
              <LayoutPrincipal>
                <PaginaSeguimientoEnVivo />
              </LayoutPrincipal>
            </ProtectedRoute>
          } />
          <Route path="/operaciones/historial" element={
            <ProtectedRoute requiredRole="user">
              <LayoutPrincipal>
                <PaginaHistorialOperaciones />
              </LayoutPrincipal>
            </ProtectedRoute>
          } />

          {/* Rutas de permisos y licencias */}
          <Route path="/licencias" element={
            <ProtectedRoute requiredRole="user">
              <LayoutPrincipal>
                <PaginaLicencias />
              </LayoutPrincipal>
            </ProtectedRoute>
          } />

          {/* Rutas de reportes */}
          <Route path="/reportes/rendimiento" element={
            <ProtectedRoute requiredRole="user">
              <LayoutPrincipal>
                <PaginaReporteRendimiento />
              </LayoutPrincipal>
            </ProtectedRoute>
          } />
          <Route path="/reportes/financiero" element={
            <ProtectedRoute requiredRole="user">
              <LayoutPrincipal>
                <PaginaReporteFinanciero />
              </LayoutPrincipal>
            </ProtectedRoute>
          } />

          {/* Rutas de configuración */}
          <Route path="/configuracion/perfil" element={
            <ProtectedRoute requiredRole="user">
              <LayoutPrincipal>
                <PaginaPerfil />
              </LayoutPrincipal>
            </ProtectedRoute>
          } />

          {/* Rutas de administración */}
          <Route 
            path="/admin" 
            element={
              <ProtectedRoute requiredRole="admin">
                <LayoutAdmin>
                  <PaginaDashboardAdmin />
                </LayoutAdmin>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/dashboard" 
            element={
              <ProtectedRoute requiredRole="admin">
                <LayoutAdmin>
                  <PaginaDashboardAdmin />
                </LayoutAdmin>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/usuarios" 
            element={
              <ProtectedRoute requiredRole="admin">
                <LayoutAdmin>
                  <PaginaGestionUsuarios />
                </LayoutAdmin>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/usuarios/roles" 
            element={
              <ProtectedRoute requiredRole="admin">
                <LayoutAdmin>
                  <PaginaRolesPermisos />
                </LayoutAdmin>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/instituciones" 
            element={
              <ProtectedRoute requiredRole="admin">
                <LayoutAdmin>
                  <PaginaGestionInstituciones />
                </LayoutAdmin>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/categorias" 
            element={
              <ProtectedRoute requiredRole="admin">
                <LayoutAdmin>
                  <PaginaGestionCategorias />
                </LayoutAdmin>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/configuracion" 
            element={
              <ProtectedRoute requiredRole="admin">
                <LayoutAdmin>
                  <PaginaConfiguracionSistema />
                </LayoutAdmin>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/configuracion/:seccion" 
            element={
              <ProtectedRoute requiredRole="admin">
                <LayoutAdmin>
                  <PaginaConfiguracionSistema />
                </LayoutAdmin>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/archivos" 
            element={
              <ProtectedRoute requiredRole="admin">
                <LayoutAdmin>
                  <PaginaGestionArchivos />
                </LayoutAdmin>
              </ProtectedRoute>
            } 
          />
          <Route 
            path="/admin/reportes" 
            element={
              <ProtectedRoute requiredRole="admin">
                <LayoutAdmin>
                  <PaginaReportesAnaliticas />
                </LayoutAdmin>
              </ProtectedRoute>
            } 
          />
          <Route path="/admin/monitoreo/logs" element={
            <ProtectedRoute requiredRole="admin">
              <LayoutAdmin>
                <PaginaAuditoriaAdmin />
              </LayoutAdmin>
            </ProtectedRoute>
          } />
          
          {/* Rutas de normatividad (Admin) */}
          <Route path="/admin/normatividad" element={
            <ProtectedRoute requiredRole="admin">
              <LayoutAdmin>
                <PaginaGestionNormativa />
              </LayoutAdmin>
            </ProtectedRoute>
          } />
          <Route path="/admin/normatividad/nueva" element={
            <ProtectedRoute requiredRole="admin">
              <LayoutAdmin>
                <PaginaEditorNormativa />
              </LayoutAdmin>
            </ProtectedRoute>
          } />
          <Route path="/admin/normatividad/editar/:id" element={
            <ProtectedRoute requiredRole="admin">
              <LayoutAdmin>
                <PaginaEditorNormativa />
              </LayoutAdmin>
            </ProtectedRoute>
          } />
          <Route path="/admin/normatividad/visor/:id" element={
            <ProtectedRoute requiredRole="admin">
              <LayoutAdmin>
                <PaginaVisorNormativa />
              </LayoutAdmin>
            </ProtectedRoute>
          } />
          
          {/* Ruta de Tarifas para Admin */}
          <Route path="/admin/tarifas/clasificacion" element={
            <ProtectedRoute requiredRole="admin">
              <LayoutAdmin>
                <PaginaBuscadorLigie />
              </LayoutAdmin>
            </ProtectedRoute>
          } />

          <Route path="/institucion/simulaciones" element={
            <ProtectedRoute requiredRole="institucion_usuario">
              <LayoutInstitucional>
                <PaginaDashboardInstitucion />
              </LayoutInstitucional>
            </ProtectedRoute>
          } />
          <Route path="/institucion/usuarios" element={
            <ProtectedRoute requiredRole="institucion_usuario">
              <LayoutInstitucional>
                <PaginaPanelUsuarios />
              </LayoutInstitucional>
            </ProtectedRoute>
          } />
          <Route path="/institucion/almacen-practica" element={
            <ProtectedRoute requiredRole="institucion_usuario">
              <LayoutInstitucional>
                <PaginaAlmacenPractica />
              </LayoutInstitucional>
            </ProtectedRoute>
          } />
          <Route path="/institucion/despacho" element={
            <ProtectedRoute requiredRole="institucion_usuario">
              <LayoutInstitucional>
                <PaginaDespachoPortuario />
              </LayoutInstitucional>
            </ProtectedRoute>
          } />
          <Route path="/institucion/jefes" element={
            <ProtectedRoute requiredRole="institucion_jefe">
              <LayoutInstitucional>
                <PaginaPanelJefes />
              </LayoutInstitucional>
            </ProtectedRoute>
          } />
          <Route path="/institucion/gestion-miembros" element={
            <ProtectedRoute requiredRole="institucion_jefe">
              <LayoutInstitucional>
                <PaginaGestionMiembros />
              </LayoutInstitucional>
            </ProtectedRoute>
          } />
          <Route path="/institucion/usuarios/perfil" element={
            <ProtectedRoute requiredRole="institucion_usuario">
              <LayoutInstitucional>
                <PaginaPerfilAlumno />
              </LayoutInstitucional>
            </ProtectedRoute>
          } />
          
          {/* Ruta de Tarifas para Institución */}
          <Route path="/institucion/tarifas/clasificacion" element={
            <ProtectedRoute requiredRole="institucion_usuario">
              <LayoutInstitucional>
                <PaginaBuscadorLigie />
              </LayoutInstitucional>
            </ProtectedRoute>
          } />

          {/* Visor de Normativa */}
          <Route path="/institucion/normas/:id" element={
            <ProtectedRoute requiredRole="institucion_usuario">
              <LayoutInstitucional>
                <PaginaVisorNormativa />
              </LayoutInstitucional>
            </ProtectedRoute>
          } />
          {/* Ruta para Jefes - Visor de Normativa */}
          <Route path="/institucion/jefes/normas/:id" element={
            <ProtectedRoute requiredRole="institucion_jefe">
              <LayoutInstitucional>
                <PaginaVisorNormativa />
              </LayoutInstitucional>
            </ProtectedRoute>
          } />
          <Route path="/institucion/clasificacion/:id" element={
            <ProtectedRoute requiredRole="institucion_usuario">
              <LayoutInstitucional>
                <PaginaVisorNormativa />
              </LayoutInstitucional>
            </ProtectedRoute>
          } />

          <Route path="/institucion/jefes/perfil" element={
            <ProtectedRoute requiredRole="institucion_jefe">
              <LayoutInstitucional>
                <PaginaPerfilJefe />
              </LayoutInstitucional>
            </ProtectedRoute>
          } />

          {/* Rutas de Dictamenes */}
          <Route path="/institucion/dictamenes/:id" element={
            <ProtectedRoute requiredRole="institucion_usuario">
              <LayoutInstitucional>
                <PaginaDetalleDictamen />
              </LayoutInstitucional>
            </ProtectedRoute>
          } />
          <Route path="/institucion/jefes/dictamenes/:id" element={
            <ProtectedRoute requiredRole="institucion_jefe">
              <LayoutInstitucional>
                <PaginaDetalleDictamen />
              </LayoutInstitucional>
            </ProtectedRoute>
          } />

          {/* Ruta Simulación Caso A */}
          <Route path="/institucion/simulacion/caso-a/:id" element={
            <ProtectedRoute requiredRole="institucion_usuario">
              <LayoutInstitucional>
                <PaginaSimulacionCasoA />
              </LayoutInstitucional>
            </ProtectedRoute>
          } />

          {/* Ruta Configuración Simulación */}
          <Route path="/institucion/simulaciones/configurar/:id" element={
            <ProtectedRoute requiredRole="institucion_maestro">
              <LayoutInstitucional>
                <PaginaConfiguracionSimulacion />
              </LayoutInstitucional>
            </ProtectedRoute>
          } />

          {/* Ruta Evaluación Simulación */}
          <Route path="/institucion/simulaciones/evaluacion/:idAsignacion" element={
            <ProtectedRoute requiredRole="institucion_maestro">
              <LayoutInstitucional>
                <PaginaEvaluacionSimulacion />
              </LayoutInstitucional>
            </ProtectedRoute>
          } />

          <Route path="/empresa" element={
            <ProtectedRoute requiredRole="empresa_usuario">
              <LayoutEmpresa>
                <PaginaPanelEmpresa />
              </LayoutEmpresa>
            </ProtectedRoute>
          } />
          <Route path="/empresa/dashboard" element={
            <ProtectedRoute requiredRole="empresa_usuario">
              <LayoutEmpresa>
                <PaginaPanelEmpresa />
              </LayoutEmpresa>
            </ProtectedRoute>
          } />
          <Route path="/empresa/gestion" element={
            <ProtectedRoute requiredRole="empresa_gestion">
              <LayoutEmpresa>
                <PaginaGestionEmpresa />
              </LayoutEmpresa>
            </ProtectedRoute>
          } />
          <Route path="/empresa/miembros" element={
            <ProtectedRoute requiredRole="empresa_admin">
              <LayoutEmpresa>
                <PaginaGestionEmpresa />
              </LayoutEmpresa>
            </ProtectedRoute>
          } />

          {/* Ruta 404 */}
          <Route path="*" element={<PaginaNoEncontrada />} />
        </Routes>

          {/* Componente de notificaciones */}
          <HotToaster
            position="top-right"
            toastOptions={{ duration: 5000 }}
            containerStyle={{ zIndex: 999999 }}
          />
          <Toaster />
        </div>
      </AuthProvider>
    </ProveedorTema>
  )
}

export default App
